import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  RefreshButton,
  Filter,
  TextInput,
  WithPermission,
  CreateButton
} from "admin-on-rest";
import { CardActions } from "material-ui/Card";

import { styles } from "./styles";
import "./index.css";

import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";

import { CategoryCreate as create, CategoryEdit as edit } from "./Create";
import { ROLE_ADMIN } from "../App";

const CategoryActions = ({ resource, basePath, refresh }) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="categories-actions"
  >
    <WithPermission value={ROLE_ADMIN}>
      <CreateButton basePath={basePath} />
    </WithPermission>
    <RefreshButton basePath={basePath} refresh={refresh} />
  </CardActions>
);
const CategoryFilter = ({ ...props }) => (
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn
    />
  </Filter>
);

export const CategoryCreate = create;
export const CategoryEdit = edit;

export const CategoriesList = props => (
  <List
    {...props}
    actions={<CategoryActions />}
    filters={<CategoryFilter />}
    title={<IconTitle icon="categories" title={"resources.categories.title"} />}
    pagination={<Pagination />}
  >
    {permissions => (
      <Datagrid bodyOptions={{ showRowHover: true }}>
        <TextField label="resources.categories.fieldList.name" source="name" />
        <DateField
          label="resources.categories.fieldList.create_at"
          source="created_at"
        />
        {permissions === ROLE_ADMIN && (
          <EditButton label="" style={{ textAlign: "right" }} {...props} />
        )}
      </Datagrid>
    )}
  </List>
);



// WEBPACK FOOTER //
// ./src/categories/index.js